import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { GoogleService } from '../services/auth/google/google.service';
import { LinkedinService } from '../services/auth/linkedin/linkedin.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Component({
  selector: 'app-sign-up',

  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css'],
})
export class SignUpComponent {
  showPassword = false;
  showConfirmPassword = false;

  googleIcon = './assets/' + environment.projectName + '/icons/google.svg';
  logo = './assets/' + environment.projectName + '/media/header/logo.png';
  lang: string = '';
  user: any = { name: '', email: '', phone: '', sub: '' }; 
  confirmPassword: string = '';
  constructor(private linkedIn: LinkedinService, private google: GoogleService, private authService: AuthService, private userInfoService: UserInfoService, private route: ActivatedRoute) {
    this.route.params.subscribe((params) => {
      if (params) {
        this.lang = params['lang'];
      }
    });
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmShowPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  
  signUp() {
    if (this.user.sub !== this.confirmPassword) {
      alert('Password and Confirm Password must be the same');
      return;
    }


    this.authService.registerUser(this.user).subscribe((response: any) => {
      this.userInfoService.setUserInfo(response);
      window.location.href = '/';
    });
  }

  registerWithLinkedIn() {
    this.linkedIn.loginWithLinkedIn();
  }

  registerWithGoogle() {
    this.google.login();
  }
}
